/*
 * ATTENTION: The "eval" devtool has been used (maybe by default in mode: "development").
 * This devtool is neither made for production nor for readable output files.
 * It uses "eval()" calls to create a separate source file in the browser devtools.
 * If you are trying to read the output file, select a different devtool (https://webpack.js.org/configuration/devtool/)
 * or disable the default devtool with "devtool: false".
 * If you are looking for production-ready output files, see mode: "production" (https://webpack.js.org/configuration/mode/).
 */
/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./src/scripts/components/ArticleHeroVideo.js":
/*!****************************************************!*\
  !*** ./src/scripts/components/ArticleHeroVideo.js ***!
  \****************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

eval("__webpack_require__.r(__webpack_exports__);\n/* harmony export */ __webpack_require__.d(__webpack_exports__, {\n/* harmony export */   \"setupArticleHeroVideo\": () => (/* binding */ setupArticleHeroVideo)\n/* harmony export */ });\nconst dom = {\n  article_section: '[data-article-hero-section]',\n  article_modal: '[data-video-modal]',\n  article_modal_open: '[data-video-modal-open]',\n  article_modal_close: '[data-video-modal-close]',\n  article_modal_backdrop: '[data-video-modal-backdrop]',\n  article_modal_video: '[data-modal-video]'\n};\n\nclass ArticleHeroVideo {\n  constructor(el) {\n    if (el) {\n      if (!el) return;\n      this.section = el;\n      this.articleModal = this.section.querySelector(dom.article_modal);\n      this.articleModalOpen = this.section.querySelector(dom.article_modal_open);\n      this.articleModalClose = this.section.querySelector(dom.article_modal_close);\n      this.articleModalBackdrop = this.section.querySelector(dom.article_modal_backdrop);\n      this.articleModalVideo = this.section.querySelector(dom.article_modal_video);\n      this.init();\n    }\n  }\n\n  init() {\n    this.handleVideoModal();\n  }\n\n  openModal(modal) {\n    modal.classList.add('active'); // Lock Body scroll\n\n    document.body.classList.add('overflow-hidden');\n  }\n\n  closeModal(modal) {\n    modal.classList.remove('active'); // Unlock Body scroll\n\n    document.body.classList.remove('overflow-hidden');\n  }\n\n  handleVideoModal = () => {\n    const modal = this.articleModal;\n\n    if (modal) {\n      this.articleModalOpen && this.articleModalOpen.addEventListener('click', event => {\n        this.openModal(modal);\n      });\n      this.articleModalClose && this.articleModalClose.addEventListener('click', event => {\n        this.closeModal(modal);\n        this.articleModalVideo.setAttribute('src', this.articleModalVideo.getAttribute('src'));\n      });\n      this.articleModalBackdrop && this.articleModalBackdrop.addEventListener('click', event => {\n        this.closeModal(modal);\n        this.articleModalVideo.setAttribute('src', this.articleModalVideo.getAttribute('src'));\n      });\n    }\n  };\n}\n\nconst setupArticleHeroVideo = () => {\n  const elements = [].slice.call(document.querySelectorAll(dom.article_section));\n\n  if (elements.length > 0) {\n    elements.forEach(element => {\n      new ArticleHeroVideo(element);\n    });\n  }\n};\n\n//# sourceURL=webpack://z-man-fishing/./src/scripts/components/ArticleHeroVideo.js?");

/***/ }),

/***/ "./src/scripts/templates/article.js":
/*!******************************************!*\
  !*** ./src/scripts/templates/article.js ***!
  \******************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

eval("__webpack_require__.r(__webpack_exports__);\n/* harmony import */ var scripts_components_ArticleHeroVideo_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! scripts/components/ArticleHeroVideo.js */ \"./src/scripts/components/ArticleHeroVideo.js\");\n\ndocument.addEventListener(\"DOMContentLoaded\", () => {\n  (0,scripts_components_ArticleHeroVideo_js__WEBPACK_IMPORTED_MODULE_0__.setupArticleHeroVideo)();\n});\n\n//# sourceURL=webpack://z-man-fishing/./src/scripts/templates/article.js?");

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module can't be inlined because the eval devtool is used.
/******/ 	var __webpack_exports__ = __webpack_require__("./src/scripts/templates/article.js");
/******/ 	
/******/ })()
;